import React, { useState } from "react";
import { Button, Col, Row, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import homephoto from "./home.svg";
import ServiceMember from "../Services/ServiceMember";
import Navbar from "../Navbar/Navbar";
import "./Home.css";
import { useEffect } from "react";

const Home = () => {
  useEffect(() => {
    getLaboratory();
  }, []);

  const setTypeItemC = () => {
    sessionStorage.setItem(
      "Type",
      JSON.stringify({
        type: "Covid",
      })
    );
  };
  const setTypeItem = () => {
    sessionStorage.setItem(
      "Type",
      JSON.stringify({
        type: "No Covid",
      })
    );
  };
  // data laboratory
  const [labo, setLaboratory] = useState();
  const [lieux, setLieux] = useState();
  const getLaboratory = () => {
    setLieux(JSON.parse(sessionStorage.getItem("lieux")));
    // ServiceMember.getLaboratory().then((res) => {
    //   setLaboratory(res.data);
    //   res.data &&
    //     sessionStorage.setItem("Laboratory", JSON.stringify(res.data));
    //   console.log("this is a laboratory data", res.data);
    // });
  };
  return (
    <>
      <Navbar />

      <Container>
        <div className="section">
          <Row>
            <Col lg={6} sm={12}>
              <div>
                <h6>
                  <span>COVID-19 : </span>
                  Masque obligatoire pour tous les rendez-vous. Services et
                  horaires ajustés.
                  {/* <a
                    className="link"
                    href="http://laboratoire-zemamra.com"
                    target="_blank"
                  >
                    www.laboratoire-zemamra.com
                  </a> */}
                </h6>
                <h4>Pour quel service voulez-vous prendre un rendez-vous ?</h4>
                <Link to="pageanalyse">
                  <Button
                    className="btn"
                    onClick={() => {
                      setTypeItem();
                    }}
                  >
                    Laboratoire, prélévements et soins
                  </Button>
                </Link>
                <br />
                <Link to="pageanalyse">
                  <Button
                    className="btnC"
                    onClick={() => {
                      setTypeItemC();
                    }}
                  >
                    Laboratoire, prélévement Covid-19
                  </Button>
                </Link>
                <hr />
                <p>
                  <h5>Patients avec symptômes apparentés à la COVID-19 : </h5>{" "}
                  <br />
                  <b>{lieux ? lieux.denomination : ""}</b> offre des services
                  pour les presonnes présentant des symptôme de COVID-19. il est
                  seulement possible d'obtenir un Render vous sur notre site web
                  <br />
                </p>
                {/* <a
                  className="link center"
                  href="http://laboratoire-zemamra.com"
                  target="_blank"
                >
                  www.laboratoire-zemamra.com
                </a> */}
              </div>
            </Col>
            <Col lg={6}>
              <img src={homephoto} alt="" width="90%" />
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default Home;
